var _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideParchment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 162 50",
    height: 48,
    width: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: 1,
    stroke: "none",
    id: "TAB_1586886978070"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    transform: "translate(1.000000, 1.000000)",
    id: "tab_1586886978070"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_c32b9f83-3a10-46bd-a3ac-9ec8cd401a2f_1586886978070",
    d: "M21,6 L21,6 C21.1052632,6.38461538 21.7894737,7.61538462 22,8",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_06a9812a-2211-4000-8acc-f30793afa2d5_1586886978070",
    d: "M7,40 C7.92307692,39.2258065 14.7692308,38.3870968 16,38",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_49c88781-fd81-4c75-8913-8053c4a6ecee_1586886978070",
    d: "M11,33.9 C11.5454545,33.2 13.1818182,33.4 14,33.1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_f0469c74-e67e-4b60-bf88-2bb507df3b7a_1586886978070",
    d: "M114,6 C114,6 114.055556,6 114.166667,6 C114.388889,6.26666667 114.777778,7.6 115,8",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_b1d88900-75b1-408e-9a2c-1d647004d8b1_1586886978070",
    d: "M124.382978,5 C124.182978,5.78787879 124.482978,5.96969697 124.682978,7",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(86.500000, 38.500000) rotate(12.000000) translate(-86.500000, -38.500000)",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_36c4f5a8-b0b8-4bca-854b-2021a8368506_1586886978070",
    d: "M86.35,36 C86.65,36.7894737 86.55,40.0789474 86.65,41",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    id: "STROKE_b34ce771-6179-4474-ba8c-96459d28b461_1586886978070",
    d: "M7,24 C7.07142857,24 7.14285714,23.8181818 7.28571429,23.4545455 L8,23",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_7d37c12c-efa9-41ce-ab15-54e7fd7a62ee_1586886978070",
    d: "M9,16.000997 C11.6666667,15.9176971 11.6666667,21.0822867 9,20.9989869 C6.33333333,21.0822867 6.33333333,16.000997 9,16.000997 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_2c7c4723-b1b8-4c64-a922-696dbc18d267_1586886978070",
    d: "M24,36.000997 C26.6666667,35.9176971 26.6666667,41.0822867 24,40.9989869 C21.3333333,41.0822867 21.3333333,36.000997 24,36.000997 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_834cbcb0-e3f2-4d21-b8e6-8b25592cc825_1586886978070",
    d: "M131.974026,5.0010131 C134.675325,4.91771327 134.675325,10.0823029 131.974026,9.99900302 C129.341991,9.99900302 129.341991,4.91771327 131.974026,5.0010131 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_015cef7a-277a-4954-9ff8-3db259346469_1586886978070",
    d: "M146,3.0010131 C148.666667,2.91771327 148.666667,8.08230286 146,7.99900302 C143.333333,7.99900302 143.333333,2.91771327 146,3.0010131 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_dce9b17a-01fa-47d6-9023-1a6e70444f66_1586886978070",
    d: "M125,36.0010131 C127.666667,35.9177133 127.666667,41.0823029 125,40.999003 C122.333333,40.999003 122.333333,35.9177133 125,36.0010131 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#000000",
    strokeWidth: 0.2,
    id: "STROKE_92724a34-73d9-4407-a09b-0709cea29a61_1586886978070",
    d: "M133,31.000997 C135.666667,30.9176971 135.666667,36.0822867 133,35.9989869 C130.333333,36.0822867 130.333333,31.000997 133,31.000997 Z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    id: "STROKE_c60e3763-a76d-49ef-8749-6adb9c33eff5_1__1586886978070",
    d: "M158,0.967494684 C152.5339,1.20917452 144.23038,0.725814846 138.916116,1.02791464 C119.481093,0.907074725 97.9962821,0.363295088 78.4853408,0.967494684 C68.0845666,1.57169428 40.9059013,-3.32232245 35.5916371,4.47185234 C25.4945352,0.302875129 11.830618,0.62621438 0.579186259,1.63043048 C0.123677902,6.8572598 -0.183303823,10.8380306 0.123677902,16.1933245 C6.19712267,18.0663432 2.17346551,16.7975241 0.579186259,20.2414618 C-0.255912397,24.1687592 0.337206705,28.0960565 1.17230536,31.902514 C1.8555679,36.313171 0.337206705,37.7926815 0.337206705,42.2033386 C0.489042824,42.4450184 0.35143208,44.5697888 0.579186259,44.8718886 C9.6740559,44.6257097 20.5070365,45.8855342 30.178051,45.9734137 C50.4173352,46.1573259 70.0303868,45.3710744 89.2831635,44.110512 C90.3460163,42.4187531 91.6191651,40.7460789 93.4411986,39.11474 L93.5930347,38.3101959 C95.0354778,40.1227947 95.263232,42.2979132 96.7815932,44.110512 C116.06478,44.7147116 138.716813,43.7843293 158,44.8718886",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(240, 238, 233)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideParchment);
export default __webpack_public_path__ + "static/media/side-parchment.1eb6bbc21ac9a00f4b4a2d5e8965e226.svg";
export { ForwardRef as ReactComponent };